import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M6.5 10C4.6 10 3 11.6 3 13.5S4.6 17 6.5 17h11c1.9 0 3.5-1.6 3.5-3.5S19.4 10 17.5 10c-.2 0-.4 0-.6.1C16.4 8.3 14.8 7 12.8 7c-1.5 0-2.9.8-3.6 2.1C8.5 9 7.5 9.4 6.5 10z" />
  </svg>
);

export default SvgComponent;
